export const blockIconsPhotoandimageEditNew = (
	<span className='material-symbols-outlined'>edit</span>
);
